export default "__VITE_ASSET__b7oBut1c__"